import { deviceModelService } from '@/service/device-model';

/**
 * 拼装展示后缀：品牌 + 营销名称（如 "Apple iPhone 13 Pro"）
 * 无品牌时仅展示营销名称
 */
function formatDisplaySuffix(item: { brand?: string | null; marketingName: string }): string {
  return [item.brand, item.marketingName].filter(Boolean).join(' ');
}

/**
 * 批量查询设备型号的品牌与营销名称
 *
 * 一次 API 调用查询多个型号，返回 model → "品牌 营销名称" 映射。
 * 只有 found===true 且有 marketingName 的条目才会出现在结果中。
 * 品牌字段存在时展示为「品牌 营销名称」，不存在时仅展示营销名称。
 *
 * @param models 设备型号数组
 * @returns Record<string, string> 格式的映射（model → 品牌 营销名称）
 */
export async function batchFetchMarketingNames(models: string[]): Promise<Record<string, string>> {
  const uniqueModels = [...new Set(models.filter(Boolean))];
  if (uniqueModels.length === 0) {
    return {};
  }

  try {
    const mappings = await deviceModelService.getMarketingNameByModel(uniqueModels);
    const result: Record<string, string> = {};
    for (const item of mappings) {
      if (item?.found && item?.marketingName) {
        result[item.model as string] = formatDisplaySuffix({ brand: item.brand, marketingName: item.marketingName });
      }
    }
    return result;
  } catch {
    return {};
  }
}
